module.exports = __webpack_public_path__ + "static/media/icon-crisis-menu.f3e40c04.svg";